module.exports = __webpack_public_path__ + "assets/logo-twolines-right-white.18715a93.svg";